/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+d9A":
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__("5Cyz");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

module.exports = toInteger;

/***/ }),

/***/ "3w4y":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe"),
    arrayMap = __webpack_require__("BblM"),
    isArray = __webpack_require__("p/0c"),
    isSymbol = __webpack_require__("bgO7");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),

/***/ "5Cyz":
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__("iS0Z");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),

/***/ "A8RV":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("3w4y");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),

/***/ "BblM":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/lodash/round.js
var round = __webpack_require__("gSU/");
var round_default = /*#__PURE__*/__webpack_require__.n(round);

// EXTERNAL MODULE: ./components/wrapper/style.css
var wrapper_style = __webpack_require__("t0U0");
var wrapper_style_default = /*#__PURE__*/__webpack_require__.n(wrapper_style);

// EXTERNAL MODULE: ./components/calc/style.css
var calc_style = __webpack_require__("Wh9W");
var calc_style_default = /*#__PURE__*/__webpack_require__.n(calc_style);

// CONCATENATED MODULE: ./components/calc/index.js



var _ref2 = Object(preact_min["h"])(
  "option",
  { value: "mildest" },
  "Mildest"
);

var _ref3 = Object(preact_min["h"])(
  "option",
  { value: "mild" },
  "Mild"
);

var _ref4 = Object(preact_min["h"])(
  "option",
  { value: "medium" },
  "Medium"
);

var _ref5 = Object(preact_min["h"])(
  "option",
  { value: "strong" },
  "Strong"
);

var _ref6 = Object(preact_min["h"])(
  "option",
  { value: "strongest" },
  "Strongest"
);

var calc_Calc = function Calc(_ref) {
  var setAmount = _ref.setAmount,
      setStength = _ref.setStength,
      ratio = _ref.ratio,
      water = _ref.water,
      strength = _ref.strength;

  return Object(preact_min["h"])(
    "form",
    { action: "javascript:", "class": calc_style_default.a.calc },
    Object(preact_min["h"])(
      "h3",
      { "class": calc_style_default.a.ratio },
      ratio,
      " Ratio"
    ),
    Object(preact_min["h"])(
      "div",
      { "class": calc_style_default.a.inputWrapper },
      Object(preact_min["h"])("input", {
        "class": calc_style_default.a.input,
        type: "number",
        id: "amount",
        min: 1,
        max: 150,
        "aria-label": "Amount of coffee in fluid ounces",
        onInput: setAmount,
        defaultValue: water
      }),
      Object(preact_min["h"])(
        "span",
        { "class": calc_style_default.a.unit },
        "fl oz"
      ),
      Object(preact_min["h"])(
        "div",
        { "class": calc_style_default.a.select },
        Object(preact_min["h"])(
          "select",
          {
            "class": calc_style_default.a.input,
            "aria-label": "Coffee strength",
            id: "strength",
            onInput: setStength,
            value: strength
          },
          _ref2,
          _ref3,
          _ref4,
          _ref5,
          _ref6
        )
      )
    )
  );
};

/* harmony default export */ var calc = (calc_Calc);
// EXTERNAL MODULE: ./components/icon/style.css
var icon_style = __webpack_require__("xAKj");
var icon_style_default = /*#__PURE__*/__webpack_require__.n(icon_style);

// CONCATENATED MODULE: ./components/icon/index.js



var icon__ref = Object(preact_min["h"])("path", { d: "M0 0h50v50H0z" });

var icon_SmallIcon = function SmallIcon() {
  return Object(preact_min["h"])(
    "svg",
    {
      width: "50",
      className: icon_style_default.a.icon,
      height: "50",
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", fillRule: "evenodd" },
      icon__ref,
      Object(preact_min["h"])("path", {
        className: icon_style_default.a.theme,
        d: "M37.95 17.425h-1v-2.85a.95.95 0 0 0-.95-.95H12.2a.95.95 0 0 0-.95.95v7.9c0 3.65 1.85 6.9 4.65 8.8H8.4a.95.95 0 0 0-.95.95c0 2.3 1.85 4.15 4.15 4.15h24.95c2.3 0 4.15-1.85 4.15-4.15a.95.95 0 0 0-.95-.95H32.3c1.05-.75 1.95-1.65 2.7-2.7h2.95c2.55 0 4.6-2.05 4.6-4.6v-1.95c0-2.55-2.05-4.6-4.6-4.6zm.65 15.8a2.29 2.29 0 0 1-2.05 1.3H11.6c-.9 0-1.65-.55-2.05-1.3H38.6zm-12.4-1.9h-4.25c-4.85 0-8.8-3.95-8.8-8.8v-6.95H35v6.95c0 4.8-3.95 8.8-8.8 8.8zm13.6-7.3c0 1-.85 1.85-1.85 1.85H36.4c.35-1.05.55-2.2.55-3.35v-2.3h1c1 0 1.85.85 1.85 1.85v1.95z",
        fill: "#6B4800"
      })
    )
  );
};

var icon__ref2 = Object(preact_min["h"])("path", { d: "M0 0h50v50H0z" });

var icon_MediumIcon = function MediumIcon() {
  return Object(preact_min["h"])(
    "svg",
    {
      width: "50",
      className: icon_style_default.a.icon,
      height: "50",
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", fillRule: "evenodd" },
      icon__ref2,
      Object(preact_min["h"])("path", {
        className: icon_style_default.a.theme,
        d: "M35.85 14.35H34.2V11.9c0-1.15-1.3-1.95-4.25-2.5-2.3-.4-5.35-.65-8.55-.65-3.2 0-6.35.2-8.65.65-2.95.55-4.25 1.3-4.25 2.5v26.2c0 1.15 1.3 1.95 4.25 2.5 2.3.4 5.35.65 8.55.65 3.2 0 6.25-.25 8.55-.65 2.95-.55 4.25-1.3 4.25-2.5v-2.45h1.65c3.2-.1 5.75-2.6 5.75-5.7v-10c0-3.1-2.55-5.6-5.65-5.6zm-3.6 23.5c-.75.5-4.5 1.45-10.95 1.45-6.45 0-10.2-.9-10.95-1.45v-25.8c.75-.5 4.5-1.45 10.95-1.45 6.45 0 10.2.9 10.95 1.45v25.8zm5.4-7.9c0 1-.8 1.8-1.8 1.8H34.2v-13.6h1.65c1 0 1.8.8 1.8 1.8v10z",
        fill: "#6B4800"
      })
    )
  );
};

var icon__ref3 = Object(preact_min["h"])("path", { d: "M0 0h50v50H0z" });

var icon__ref4 = Object(preact_min["h"])("path", { d: "M26.979 41.83v-.418c5.345-.501 8.436-5.178 8.436-12.695s-3.174-12.195-8.436-12.696v-4.009a.928.928 0 0 0-.919-.919h-.752c-.584-3.34-3.925-5.011-8.269-5.345l-.417-1.253h-3.425l-.417 1.253c-4.343.418-7.684 2.005-8.269 5.345H1.504a.928.928 0 0 0-.919.919c0 .501.418.919.919.919 1.504 0 2.756 1.253 2.756 2.756V41.83c0 1.503.752 2.84 1.922 3.675L4.01 48.846a.53.53 0 0 0 0 .501c.083.167.25.25.418.25h3.09c.083 0 .25-.083.334-.167l3.174-3.09h10.44l3.174 3.09c.084.084.167.167.334.167h2.172a.457.457 0 0 0 .417-.25.53.53 0 0 0 0-.501l-2.255-3.508c1.003-.835 1.671-2.088 1.671-3.508zm5.262-13.113c0 4.092-.919 8.853-5.262 9.438v-18.96c4.259.585 5.262 5.429 5.262 9.522zM5.096 12.847h8.853v.836H5.597c-.167-.251-.251-.501-.501-.836zm.835 1.921h8.102v4.594H7.1v22.05h.084c.25 1.17 1.253 2.088 2.505 2.088h11.694c1.253 0 2.255-.918 2.505-2.088h.084V19.279h-8.269v-4.594h3.592c.25 0 .501-.251.501-.501 0-.251-.251-.501-.501-.501h-3.592v-.836h9.355v.836h-2.84c-.251 0-.501.25-.501.501 0 .25.25.501.501.501h2.84v27.061a2.639 2.639 0 0 1-2.673 2.673H8.687a2.639 2.639 0 0 1-2.673-2.673V15.604c0-.251 0-.585-.083-.836z" });

var icon__ref5 = Object(preact_min["h"])("circle", { cx: "14.868", cy: "2.156", r: "1.754" });

var icon_LargeIcon = function LargeIcon() {
  return Object(preact_min["h"])(
    "svg",
    {
      width: "50",
      height: "50",
      className: icon_style_default.a.icon,
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", fillRule: "evenodd" },
      icon__ref3,
      Object(preact_min["h"])(
        "g",
        { className: icon_style_default.a.theme, transform: "translate(7)", fill: "#6B4800" },
        icon__ref4,
        icon__ref5
      )
    )
  );
};

var icon__ref6 = Object(preact_min["h"])("path", { d: "M0 0h50v50H0z" });

var icon_LolokIcon = function LolokIcon() {
  return Object(preact_min["h"])(
    "svg",
    {
      width: "50",
      height: "50",
      className: icon_style_default.a.icon,
      xmlns: "http://www.w3.org/2000/svg"
    },
    Object(preact_min["h"])(
      "g",
      { fill: "none", "fill-rule": "evenodd" },
      icon__ref6,
      Object(preact_min["h"])("path", {
        className: icon_style_default.a.theme,
        d: "M17.87 20.561c-2.25-1.145-3.747-2.82-3.969-4.708V8.164a58.26 58.26 0 0 1-.928-.173.567.567 0 0 1-.227-1.008l4.984-3.706a12.186 12.186 0 0 1 14.546 0l4.979 3.702a.566.566 0 0 1-.228 1.014c-.308.059-.615.116-.922.17v7.69c-.228 1.936-1.796 3.648-4.141 4.794l2.523 27.065a.531.531 0 0 1-.523.581l-2.074.022-1.354-12.189c-1.266.396-2.817.931-4.033 1.291v11.65a.54.54 0 0 1-.536.536h-2.121a.523.523 0 0 1-.523-.523V37.267c-1.191-.354-2.766-.824-4.03-1.173l-1.357 12.221-2.075-.022a.532.532 0 0 1-.523-.581l2.532-27.151zm3.026 1.098L19.52 34.052l3.803.654V22.059a16.745 16.745 0 0 1-2.427-.4zm8.038.042a17.03 17.03 0 0 1-2.431.374V34.7l3.802-.653-1.371-12.346zM15.659 8.453a62.628 62.628 0 0 0 17.721.135l.001.005c.33-.044.659-.09.988-.14.037 2.248-.024 4.497-.024 6.745 0 0-.06.573-.269 1.092-2.27 5.646-12.226 5.42-16.317 2.283-1.062-.814-1.966-1.969-2.097-3.341-.072-2.258-.015-4.519-.003-6.779z",
        fill: "#6B4800"
      }),
      Object(preact_min["h"])("path", {
        className: icon_style_default.a.theme,
        d: "M32.59 11.471a.532.532 0 0 0-.833-.436c-.981.69-2.642 1.59-4.85 1.531-4.042-.109-4.578-2.902-9.239-.761a.57.57 0 0 0-.334.519c-.002.802-.003 2.671-.003 2.671.348 2.638 3.689 3.72 6.487 3.961 2.604.225 5.38-.156 7.435-1.838.657-.537 1.207-1.258 1.335-2.1l.002-3.547z",
        fill: "#6B4800"
      })
    )
  );
};

var _ref8 = Object(preact_min["h"])(icon_SmallIcon, null);

var _ref9 = Object(preact_min["h"])(icon_MediumIcon, null);

var _ref10 = Object(preact_min["h"])(icon_LargeIcon, null);

var _ref11 = Object(preact_min["h"])(icon_LolokIcon, null);

var Svg = function Svg(_ref7) {
  var size = _ref7.size;

  if (size === 'small') {
    return _ref8;
  } else if (size === 'medium') {
    return _ref9;
  } else if (size === 'large') {
    return _ref10;
  } else {
    return _ref11;
  }
};

/* harmony default export */ var icon = (Svg);
// CONCATENATED MODULE: ./components/wrapper/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var wrapper_Wrapper = function (_Component) {
  _inherits(Wrapper, _Component);

  function Wrapper() {
    var _temp, _this, _ret;

    _classCallCheck(this, Wrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      ratio: '1:16',
      strength: 'mildest',
      water: 10,
      waterConverted: 296,
      beans: 18.5,
      icon: 'small',
      waterClassName: 'title',
      coffeBeanClassName: 'title'
    }, _this.setStength = function (e) {
      var strength = e.target.value;

      switch (strength) {
        case 'mildest':
          _this.setState({ ratio: '1:16', strength: strength });
          break;
        case 'mild':
          _this.setState({ ratio: '1:15', strength: strength });
          break;
        case 'medium':
          _this.setState({ ratio: '1:13', strength: strength });
          break;
        case 'strong':
          _this.setState({ ratio: '1:11', strength: strength });
          break;
        case 'strongest':
          _this.setState({ ratio: '1:10', strength: strength });
          break;
        default:
          console.error('Oops. No stength set.');
      }

      _this.setAmount(null, strength);
    }, _this.setAmount = function (e, strength) {
      var amount = e !== null ? e.target.value : null;
      strength = strength || _this.state.strength;

      switch (strength) {
        case 'mildest':
          _this.calculateCoffee(amount, 16);
          break;
        case 'mild':
          _this.calculateCoffee(amount, 15);
          break;
        case 'medium':
          _this.calculateCoffee(amount, 13);
          break;
        case 'strong':
          _this.calculateCoffee(amount, 11);
          break;
        case 'strongest':
          _this.calculateCoffee(amount, 10);
          break;
        default:
          console.error('Oops. No stength set.');
      }
    }, _this.calculateCoffee = function (brewedCoffee, ratioNum) {
      brewedCoffee = brewedCoffee === null ? _this.state.water : brewedCoffee;
      var waterInGrams = round_default()(brewedCoffee * 29.57, 1);
      var coffeeBeans = round_default()(brewedCoffee * 29.5735 / ratioNum, 1);

      // We only want to show one decimal place if the number is under three digits.
      waterInGrams = waterInGrams >= 100 ? round_default()(waterInGrams) : waterInGrams;
      coffeeBeans = coffeeBeans >= 100 ? round_default()(coffeeBeans) : coffeeBeans;

      // Check the length of the digits so we can reduce the font size a bit.
      var waterDigits = (waterInGrams + '').replace('.', '').length;
      var coffeeBeanDigits = (coffeeBeans + '').replace('.', '').length;

      // Update the icon if necessary.
      _this.updateIcon(brewedCoffee);

      // Set our new water / bean strings.
      _this.setState({
        water: brewedCoffee,
        waterConverted: waterInGrams,
        beans: coffeeBeans,
        waterClassName: waterDigits >= 4 && waterInGrams <= 17742 ? 'titleLarge' : 'title',
        coffeBeanClassName: coffeeBeanDigits >= 4 && waterInGrams <= 17742 ? 'titleLarge' : 'title'
      });
    }, _this.updateIcon = function (amount) {
      if (amount <= 12) {
        _this.setState({ icon: 'small' });
      } else if (amount > 12 && amount <= 16) {
        _this.setState({ icon: 'medium' });
      } else if (amount > 16 && amount <= 99) {
        _this.setState({ icon: 'large' });
      } else {
        _this.setState({ icon: 'lolok' });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Retrieve persisted state from local storage.
  Wrapper.prototype.getLocalStorage = function getLocalStorage() {
    return JSON.parse(localStorage.getItem('calc.coffee') || '{}');
  };

  // Persist the state in local storage if it's available.


  Wrapper.prototype.componentDidMount = function componentDidMount() {
    var localStorageState = this.getLocalStorage();
    this.setState(localStorageState);
  };

  // Update local storage after the state updates.


  Wrapper.prototype.componentDidUpdate = function componentDidUpdate() {
    localStorage.setItem('calc.coffee', JSON.stringify(this.state));

    // Update the theme color too.
    this.props.updateTheme(this.state.strength);
  };

  Wrapper.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      { 'class': wrapper_style_default.a.wrapper },
      Object(preact_min["h"])(
        'div',
        { 'class': wrapper_style_default.a.top },
        Object(preact_min["h"])(
          'h2',
          { 'class': wrapper_style_default.a[this.state.coffeBeanClassName] },
          this.state.waterConverted > 17742 ? Object(preact_min["h"])(
            'span',
            { 'class': wrapper_style_default.a.lolk },
            'lol'
          ) : this.state.beans,
          Object(preact_min["h"])(
            'span',
            { 'class': wrapper_style_default.a.unit },
            'g'
          )
        ),
        Object(preact_min["h"])(
          'h3',
          { 'class': wrapper_style_default.a.label },
          'Coffee'
        ),
        Object(preact_min["h"])(
          'h2',
          { 'class': wrapper_style_default.a[this.state.waterClassName] },
          this.state.waterConverted > 17742 ? Object(preact_min["h"])(
            'span',
            { 'class': wrapper_style_default.a.lolk },
            'ok'
          ) : this.state.waterConverted,
          this.state.waterConverted > 17742 ? Object(preact_min["h"])(
            'span',
            { 'class': wrapper_style_default.a.unit },
            '\uD83D\uDE02'
          ) : Object(preact_min["h"])(
            'span',
            { 'class': wrapper_style_default.a.unit },
            'g'
          )
        ),
        Object(preact_min["h"])(
          'h3',
          { 'class': wrapper_style_default.a.label },
          'Water'
        )
      ),
      Object(preact_min["h"])(calc, {
        setAmount: this.setAmount,
        setStength: this.setStength,
        ratio: this.state.ratio,
        water: this.state.water,
        strength: this.state.strength
      }),
      Object(preact_min["h"])(icon, { size: this.state.icon })
    );
  };

  return Wrapper;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




if (false) {
  require('preact/debug');
}

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    app__classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = app__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateTheme = function (strength) {
      document.body.className = strength;
    }, _temp), app__possibleConstructorReturn(_this, _ret);
  }

  App.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      { id: 'app' },
      Object(preact_min["h"])(wrapper_Wrapper, { updateTheme: this.updateTheme })
    );
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "MIhM":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("j3D9");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "OuyB":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "W6LD":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("+d9A"),
    toNumber = __webpack_require__("iS0Z"),
    toString = __webpack_require__("A8RV");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function (number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;

/***/ }),

/***/ "Wh9W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"calc":"calc__1zXF6","ratio":"ratio__L7fKp","input":"input__11YsG","select":"select__3f3hY","inputWrapper":"inputWrapper__3z71Z","unit":"unit__1p58r"};

/***/ }),

/***/ "bgO7":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("e5TX"),
    isObjectLike = __webpack_require__("OuyB");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "e5TX":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe"),
    getRawTag = __webpack_require__("uiOY"),
    objectToString = __webpack_require__("lPmd");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "gSU/":
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__("W6LD");

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "iS0Z":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("u9vI"),
    isSymbol = __webpack_require__("bgO7");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),

/***/ "j3D9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "lPmd":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "p/0c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t0U0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2HFnK","top":"top__2LB40","title":"title__2eLgg","titleLarge":"titleLarge__3dvlb title__2eLgg","lolk":"lolk__3e6xY","unit":"unit__132Ho","btnGram":"btnGram__1a6MN unit__132Ho","btnGramText":"btnGramText__jAdT6","label":"label__2OZYL"};

/***/ }),

/***/ "u9vI":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "uiOY":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "wppe":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("MIhM");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

/***/ }),

/***/ "xAKj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__2Q675","theme":"theme__19o0R"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.6d467.js